export default "__VITE_ASSET__BAlUApZG__"